import HomePage from "./components/Home";

function App() {
  return <HomePage />;
}

export default App;
